(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
(function () {
  'use strict';

  function initProduct(root) {
    var items = root.querySelectorAll('[data-pp-item]');
    var thumbs = root.querySelectorAll('[data-pp-thumb]');

    function showMedia(id) {
      var target = String(id);
      items.forEach(function (el) {
        el.classList.toggle('is-active', el.getAttribute('data-media-id') === target);
      });
      thumbs.forEach(function (t) {
        t.classList.toggle('is-active', t.getAttribute('data-target') === target);
      });
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        showMedia(t.getAttribute('data-target'));
      });
    });

    /* Varianti */
    var dataEl = root.querySelector('[data-pp-variants]');
    var wrap = root.querySelector('[data-pp-form-wrap]');
    if (!dataEl || !wrap) { return; }

    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var idInput = wrap.querySelector('[data-pp-id]');
    var priceEl = root.querySelector('[data-pp-price]');
    var cta = wrap.querySelector('[data-pp-cta]');
    var ctaLabel = wrap.querySelector('[data-pp-cta-label]');
    var ctaPrice = wrap.querySelector('[data-pp-cta-price]');
    var blocks = wrap.querySelectorAll('[data-option]');
    if (!blocks.length || !idInput) { return; }

    function selectedValues() {
      var values = [];
      blocks.forEach(function (block) {
        var position = parseInt(block.getAttribute('data-position'), 10);
        var el = block.querySelector('input[type="radio"]:checked') || block.querySelector('select');
        var value = el ? el.value : '';
        values[position - 1] = value;
        var label = block.querySelector('[data-selected-label]');
        if (label) { label.textContent = value; }
      });
      return values;
    }

    function findVariant(values) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (v.options.length !== values.length) { continue; }
        var same = true;
        for (var j = 0; j < values.length; j++) {
          if (v.options[j] !== values[j]) { same = false; break; }
        }
        if (same) { return v; }
      }
      return null;
    }

    function setButton(available, text) {
      if (!cta) { return; }
      cta.disabled = !available;
      if (ctaLabel) { ctaLabel.textContent = text; }
    }

    function update() {
      var variant = findVariant(selectedValues());

      if (!variant) {
        setButton(false, 'Non disponibile');
        return;
      }

      idInput.value = variant.id;
      idInput.dispatchEvent(new Event('change', { bubbles: true }));

      if (priceEl) {
        priceEl.innerHTML = (variant.compare ? '<s>' + variant.compare + '</s> ' : '') + variant.price;
      }
      if (ctaPrice) { ctaPrice.textContent = variant.price_plain; }

      setButton(
        variant.available,
        variant.available ? cta.getAttribute('data-label') : cta.getAttribute('data-soldout')
      );

      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState(null, '', url.toString());
      } catch (e) { /* ignora */ }

      if (variant.media) { showMedia(variant.media); }
    }

    blocks.forEach(function (block) {
      block.addEventListener('change', update);
    });
  }

  function boot() { document.querySelectorAll('[data-pp]').forEach(initProduct); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Rilancia l'init quando la sezione viene ricaricata dall'editor */
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-pp]');
    if (root) { initProduct(root); }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
